module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    attrs: {
      "id": "int"
    }
  }), _vm._v("INTRODUCTION")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("There’s nothing quite like a cheese ball. No other food can gather people so quickly around the table or induce bigger smiles. Not just limited to holiday get-togethers, this little book of cheese in the round will guide and inspire you to live that cheese ball lifestyle all year long. From family-friendly balls to please a variety of tastes to lazy weekend luxuries, from fresh, light balls that give a break from the decadence to seasonal balls that get fancy, each no-fuss recipe is just the right amount of indulgent.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("For most of the recipes, unless noted otherwise, it is easier to combine the dairy ingredients if they sit at room temperature for about 30 minutes or so to soften up. In addition, the stand mixer (or any sort of blending kitchen appliance, such as a handheld mixer or food processor) makes these straightforward recipes even easier to pull off. However, if you find yourself in a situation where your guests text that they’re five minutes away, you still haven’t hidden all your messy things, and you may or may not be wearing pants, don’t overthink it—just use your hands.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "font2"
  }, [_vm._v("Happy cheese balling!")])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }, [_c('h2', [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    attrs: {
      "id": "pg8lev1"
    }
  }), _c('span', {
    staticClass: "font1a"
  }, [_vm._v("Cheese-Scaping")])]), _vm._v(" "), _c('h3', [_c('a', {
    attrs: {
      "id": "pg8lev2"
    }
  }), _vm._v("THE BASIC BALL")]), _vm._v(" "), _c('p', {
    staticClass: "first1_indent"
  }, [_vm._v("Here’s how to shape a basic cheese ball so you get that perfectly round shape. It’s easier than you think.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_c('strong', [_vm._v("1.")]), _vm._v(" Spoon the cheese mixture onto the center of a large piece of plastic wrap.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_c('strong', [_vm._v("2.")]), _vm._v(" Gather the ends of the plastic and twist to close, forming a ball with the cheese mixture. Refrigerate for at least 30 minutes to set. (The cheese ball can be refrigerated overnight.)")]), _vm._v(" "), _c('h3', [_c('a', {
    attrs: {
      "id": "pg8lev3"
    }
  }), _vm._v("HOW TO TOAST NUTS")]), _vm._v(" "), _c('p', {
    staticClass: "first1_indent"
  }, [_vm._v("Quite a few recipes in this book call for nuts, either in the cheese ball or to decorate the outside. Toasted nuts take your cheese ball to the next level.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_c('strong', [_vm._v("1.")]), _vm._v(" Preheat the oven to 350°F [180°C]. Spread the nuts into a single layer on a rimmed baking sheet and bake until toasted and fragrant, 8 to 10 minutes. Set aside to cool.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_vm._v("Not all cheese balls, despite the name, must be round to be enjoyed. The following shaping and decorating ideas range from simple to more daring, involved projects. For the best results, all of these shapes should be made after making any of the cheese ball recipes in the following chapters, but before adding the toppings.")]), _vm._v(" "), _c('h3', [_c('a', {
    attrs: {
      "id": "pg8lev4"
    }
  }), _vm._v("CHEESE WHEEL")]), _vm._v(" "), _c('p', {
    staticClass: "first1_indent"
  }, [_vm._v("This shape is perfect for cheese balls that feature a topping that is drizzled "), _c('a', {
    attrs: {
      "href": "#/xhtml/41chapter31#pg82lev1"
    }
  }, [_vm._v("(like the Brie with Cranberries, page 82)")]), _vm._v(" or is paired with stackable ingredients "), _c('a', {
    attrs: {
      "href": "#/xhtml/19chapter11#pg39lev1"
    }
  }, [_vm._v("(like the Queso, page 39)")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_c('strong', [_vm._v("1 cheese ball, without the topping")])]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_c('strong', [_vm._v("1.")]), _vm._v(" Remove the cheese ball from the fridge and remove the plastic wrap. Do not discard the plastic.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_c('strong', [_vm._v("2.")]), _vm._v(" Using the palms of your hands, push down on the ball to create a flat top. The wheel should be about 3 to 4 in [7.5 to 10 cm] wide and 1 "), _c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("2")]), _vm._v(" in [4 cm] tall.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('strong', [_vm._v("3.")]), _vm._v(" Rotate the cheese wheel and use the plastic wrap to smooth out the sides. Continue with the chosen recipe or re-cover in plastic and refrigerate if not immediately using.")]), _vm._v(" "), _c('h3', [_c('a', {
    attrs: {
      "id": "pg9lev1"
    }
  }), _vm._v("CHEESE LOG")]), _vm._v(" "), _c('p', {
    staticClass: "first1_indent"
  }, [_vm._v("This classic shape is ideal for cheese balls that blur the lines between spread and ball, like Horchata "), _c('a', {
    attrs: {
      "href": "#/xhtml/22chapter14#pg45lev1"
    }
  }, [_vm._v("(page 45)")]), _vm._v(" and Mushroom and Herb "), _c('a', {
    attrs: {
      "href": "#/xhtml/45chapter34#pg90lev1"
    }
  }, [_vm._v("(page 90)")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_c('strong', [_vm._v("1 cheese ball, without the topping")])]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_c('strong', [_vm._v("1.")]), _vm._v(" Remove the cheese ball from the fridge and remove the plastic wrap. Discard the plastic.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_c('strong', [_vm._v("2.")]), _vm._v(" Tear off a large piece of clean plastic wrap, place it on a work surface, and place the ball in the center. Drape half of the plastic wrap over the top of the cheese ball.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_c('strong', [_vm._v("3.")]), _vm._v(" Using the palms of your hands, roll the cheese ball back and forth, slowly pushing the ball outward to form a log shape that’s approximately 7 to 8 in [17 to 20 cm] long and 1 "), _c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("2")]), _vm._v(" in [4 cm] tall.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_c('strong', [_vm._v("4.")]), _vm._v(" Gently press the ends until smooth. Continue with the chosen recipe or re-cover in plastic and refrigerate if not immediately using (simply reroll the bottom if it flattens).")]), _vm._v(" "), _c('h3', [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('a', {
    attrs: {
      "id": "pg10lev1"
    }
  }), _vm._v("MINI BALLS")]), _vm._v(" "), _c('p', {
    staticClass: "first1_indent"
  }, [_vm._v("These lend themselves to creating eye-catching presentations for parties: stack them on top of each other, distribute them randomly around your food spread, stick the suggested dipper or cracker into each ball. Try recipes that don’t have complex mix-ins or toppings, like the Garden Herb "), _c('a', {
    attrs: {
      "href": "#/xhtml/26chapter17#pg53lev1"
    }
  }, [_vm._v("(page 53)")]), _vm._v(", which will be easier to divide into mini balls.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_c('strong', [_vm._v("1 cheese ball, without the topping")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('strong', [_vm._v("1 topping")])]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_c('strong', [_vm._v("1.")]), _vm._v(" Remove the cheese ball from the fridge and remove the plastic wrap. Discard the plastic.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_c('strong', [_vm._v("2.")]), _vm._v(" Using an ice cream scoop, divide the cheese ball into small mounds, approximately 1 Tbsp each; you should get 12 to 15 mini balls from an 8-oz [230-g] cheese ball.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_c('strong', [_vm._v("3.")]), _vm._v(" Using the palms of your hands, roll each mound into a smooth, even ball.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_c('strong', [_vm._v("4.")]), _vm._v(" Continue with the chosen recipe or cover each mini ball in plastic and refrigerate if not immediately using. Roll each mini ball in the chosen topping just before serving.")]), _vm._v(" "), _c('h3', [_c('a', {
    attrs: {
      "id": "pg10lev2"
    }
  }), _vm._v("OWL")]), _vm._v(" "), _c('p', {
    staticClass: "first1_indent"
  }, [_vm._v("The owl and hedgehog shapes are best with recipes that use nuts as the garnish, like the Classic "), _c('a', {
    attrs: {
      "href": "#/xhtml/08chapter01#pg17lev1"
    }
  }, [_vm._v("(page 17)")]), _vm._v(", because they’ll be easy to apply and have the biggest visual impact. For a more striking presentation, I recommend doubling the recipe (both the topping and cheese ball) so that you can make a large owl.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_c('strong', [_vm._v("1 cheese ball, without the topping")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('strong', [_vm._v("1 topping")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('strong', [_vm._v("3 small nuts (such as pistachios or peanuts)")])]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_c('strong', [_vm._v("1.")]), _vm._v(" Remove the cheese ball from the fridge and remove the plastic wrap. Discard the plastic.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_c('strong', [_vm._v("2.")]), _vm._v(" To make the feet, using an ice cream scoop, scoop about 2 Tbsp "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("from the cheese ball. Divide the mixture in half. Using the palms of your hands, roll each mound into a smooth, even ball and set aside.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_c('strong', [_vm._v("3.")]), _vm._v(" To make the body and head, using the palms of your hands, roll the remaining cheese ball into a large, rounded oval. Place one end of the oval on a serving plate and gently press down to flatten the top. As you press down to create the head, the bottom should also flatten, which helps to create a stable base for the owl to stand on its own (it’s best to work on the serving plate since it will be hard to move the owl once finished). With your fingers, pinch the top of the head to form two ears.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_c('strong', [_vm._v("4.")]), _vm._v(" Smooth out the body and ears with your hands and place the feet at the base of the body.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_c('strong', [_vm._v("5.")]), _vm._v(" To create the feathers, coat the back of the owl with three-quarters of the topping, starting from the bottom and working your way up to the back of the head. Place a thin layer in between the ears.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_c('strong', [_vm._v("6.")]), _vm._v(" To form the face, pat a little of the leftover topping on the side of the head, going in about "), _c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("4")]), _vm._v(" in [6 mm]. To make the eyes, place 2 nuts about 1 in [2.5 cm] apart from each other in the middle of the face. To make the nose, cut the last nut in half crosswise and place one half of the nut, pointed-side facing down, slightly below the eyes. Discard the other half of the nut. Refrigerate if not using immediately.")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0011-01.jpg"
    }
  })])]), _vm._v(" "), _c('h3', [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('a', {
    attrs: {
      "id": "pg12lev1"
    }
  }), _vm._v("HEDGEHOG")]), _vm._v(" "), _c('p', {
    staticClass: "first1_indent"
  }, [_vm._v("Whip up this beautifully kitschy shape for any retro-inspired shindig. Much like the Owl, the bigger the Hedgehog the better, so consider doubling the recipe.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_c('strong', [_vm._v("1 cheese ball, without the topping")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('strong', [_vm._v("5 small nuts (such as pistachios or peanuts)")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('strong', [_vm._v("1 "), _c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("2")]), _vm._v(" to 2 cups [150 g to 200 g] sliced almonds or 1 topping")])]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_c('strong', [_vm._v("1.")]), _vm._v(" Remove the cheese ball from the fridge and remove the plastic wrap. Discard the plastic.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_c('strong', [_vm._v("2.")]), _vm._v(" To make the body, using the palms of your hands, roll the cheese ball into a large, rounded oval. Place the oval, rounded-side down, on a plate and gently press down to flatten the bottom, which helps to create a stable base for the hedgehog to stand on its own (it’s best to work on the serving plate since it will be hard to move the hedgehog once finished).")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_c('strong', [_vm._v("3.")]), _vm._v(" To form the snout, determine which end of the oval will be the front of the hedgehog. With your fingers, shape the front into a rounded triangle to form the snout, shaping the tip so that it points out and off of the plate.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_c('strong', [_vm._v("4.")]), _vm._v(" To make the nose, cut a nut in half and place at the end of the snout. To make the eyes, place 2 nuts about 1 in [2.5 cm] from the nose tip, about a "), _c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("2")]), _vm._v(" in [1.25 cm] apart.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_c('strong', [_vm._v("5.")]), _vm._v(" If using sliced almonds for the quills, starting at the end of the hedgehog, place the sliced almonds at an angle into the cheese, working in horizontal rows. Continue placing the almonds in rows until about 1 in [2.5 cm] above the eyes. If using a topping for the quills, press the topping onto the body of the hedgehog, starting from the end and working up the body until about 1 in [2.5 cm] above the eyes. Refrigerate if not using immediately.")]), _vm._v(" "), _c('h3', [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "pg13lev1"
    }
  }), _vm._v("PUMPKIN")]), _vm._v(" "), _c('p', {
    staticClass: "first1_indent"
  }, [_vm._v("This quick, under-five-minutes trick will transform any cheese ball into a pumpkin work of art. Complete the fall fantasy by using this shape for the Pumpkin Pie ball "), _c('a', {
    attrs: {
      "href": "#/xhtml/40chapter30#pg79lev1"
    }
  }, [_vm._v("(page 79)")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_c('strong', [_vm._v("1 cheese ball, without the topping")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('strong', [_vm._v("Four 14-in [35.5-cm] pieces of kitchen twine")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('strong', [_vm._v("1 topping")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('strong', [_vm._v("1 bell pepper stem (for savory cheese balls) or 1 cinnamon stick (for sweet cheese balls)")])]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_c('strong', [_vm._v("1.")]), _vm._v(" Remove the cheese ball from the fridge, keeping it covered in plastic wrap.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_c('strong', [_vm._v("2.")]), _vm._v(" On a flat surface, lay out a piece of kitchen twine. Lay another piece of twine perpendicular to the first, forming a cross. Place the remaining two pieces of twine across the upper-left and -right sections respectively, forming an X, so that there are eight spaces. Place the wrapped cheese ball in the center, where all the twine pieces intersect. Tie together the ends of each of the four pieces tightly on top of the cheese ball.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_c('strong', [_vm._v("3.")]), _vm._v(" Press down on the very top, where the knots of twine intersect, with your index finger until the sections begin to expand out.")]), _vm._v(" "), _c('p', {
    staticClass: "method_txt"
  }, [_c('strong', [_vm._v("4.")]), _vm._v(" Gently cut away the twine and remove the plastic wrap. Smooth out any areas where the plastic wrap made impressions. Refrigerate if not using immediately. About 1 minute before serving, pat the outside of the pumpkin ball with the chosen topping and place the bell pepper stem or cinnamon stick on top.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-80969ada","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06-introduction.vue
// module id = 72
// module chunks = 0